<div formGroupName="splits" class="flex flex-col mt-4" [ngClass]="{ 'opacity-40': disabled }">
  <label style="font-size: 0.75rem">{{ label }}</label>
  <div class="flex items-center gap-2">
    <mat-form-field class="nopadding input-mini zeroSuffix w-24 !text-right">
      <input matInput type="number" [formControlName]="controlName" [value]="fieldValue" [max]="100" [min]="0" />
      <div matSuffix>%</div>
    </mat-form-field>

    <div class="flex-1 relative">
      <mat-slider
        class="nopadding w-full"
        [max]="100"
        [min]="0"
        [step]="1"
        [thumbLabel]="true"
        [value]="fieldValue"
        [formControlName]="controlName"></mat-slider>
      <div *ngIf="!disabled" class="w-full text__xsmall flex justify-between absolute top-1 left-0 py-0 px-2">
        <span class="text-grass-darker">
          Manager {{ controlName === 'host_service_fee' ? 'pays' : 'earns' }}: {{ fieldValue }}%
        </span>
        <span class="text-night-lighter">
          Owner {{ controlName === 'host_service_fee' ? 'pays' : 'earns' }}: {{ 100 - fieldValue }}%
        </span>
      </div>
    </div>
  </div>
</div>
